import { Card } from "@/shared/ui/card.tsx";
type ResultDetailProps = {
  label: string,
  content: string | number,
}
const ResultDetail = ({ label, content }: ResultDetailProps) => {
  return (
    <Card className="flex flex-col gap-1 p-3 my-2">
      <p className="text-lg text-gray-700 ">{label}</p>
      <p className="text-sm text-gray-700">{content}</p>
    </Card>
  )
}

export default ResultDetail;
